import React from "react";
import "./App.css";
import AppRoutes from "./app/app-routes";
import { MsalProvider } from "@azure/msal-react";
import { UserProvider } from "./context/UserContext";
import ClientContextProvider from "./context/ClientContext";
import SchemeContextProvider from "./context/SchemeContext";
import ValueContextProvider from "./context/ValueContext";
import { SelectedClientRowProvider } from "./context/SelectedClientRowContext";
import { SelectedSchemeRowProvider } from "./context/SelectedSchemeRowContext";
import AccessTokenProvider from "./context/AccessTokenContext";
import DataChecksContextProvider from "./context/DataChecksContext";
import { AccessTokenProviderV2 } from "./context/AccessTokenContextV2";
import ModuleOptionIdsProvider from "./context/ModuleOptionsContext";
import { ThemeProvider } from "./context/ThemeContext";
import { NotificationProvider } from "./context/NotificationContext";
import { UnloadWarningProvider } from "./context/UnloadWarningContext";

const App = ({ msaLInstance }: any) => {
  return (
      <MsalProvider instance={msaLInstance}>
        <UnloadWarningProvider>
          <ModuleOptionIdsProvider>
        <ValueContextProvider>
        <AccessTokenProviderV2>
        <NotificationProvider>
        <DataChecksContextProvider>
        <AccessTokenProvider>
        <ClientContextProvider>
          <SelectedClientRowProvider>
            <SelectedSchemeRowProvider>
          <SchemeContextProvider>
        <UserProvider>
        <ThemeProvider>
              <AppRoutes />
          </ThemeProvider>
        </UserProvider>
        </SchemeContextProvider>
        </SelectedSchemeRowProvider>
        </SelectedClientRowProvider>
        </ClientContextProvider>
        </AccessTokenProvider>
        </DataChecksContextProvider>
        </NotificationProvider>
        </AccessTokenProviderV2>
        </ValueContextProvider>
        </ModuleOptionIdsProvider>
  </UnloadWarningProvider>
      </MsalProvider>
  );
};

export default App;
